import { AlertTriangle, Scale, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export function LegalDisclaimer({ className = "" }) {
  return (
    <div className={`border-2 border-[#E63946] bg-[#FDECEC] p-4 rounded-sm ${className}`} data-testid="legal-disclaimer">
      <p className="flex items-center gap-2 text-[#E63946] font-bold text-sm mb-1.5">
        <AlertTriangle size={16} /> Important — this is not legal advice
      </p>
      <p className="text-xs text-neutral-700 leading-relaxed mb-3">
        NC Legal Forms provides general filing information and self-help form tools only. We are not a law firm,
        are not a substitute for an attorney, and do not provide legal advice, opinions, or representation. Court
        rules, fees, and requirements vary by county — confirm the current requirements with your local Clerk of
        Superior Court before filing.
      </p>
      <div className="flex flex-col sm:flex-row sm:items-center gap-2">
        <span className="text-xs font-semibold text-primary flex items-center gap-1.5"><Scale size={13} /> Need legal help?</span>
        <Link to="/find-attorney" data-testid="attorney-referral-link"
          className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#E63946] hover:underline">
          Browse NC attorneys by practice area <ArrowRight size={12} />
        </Link>
      </div>
    </div>
  );
}
